'use client'
import { useEffect, useRef } from 'react'

const GORIS_LAT = 39.5127
const GORIS_LNG = 46.3543

export function HomepageMap() {
  const mapRef = useRef<HTMLDivElement>(null)
  const mapInstance = useRef<any>(null)

  useEffect(() => {
    const el = mapRef.current
    if (!el || mapInstance.current || el.classList.contains('leaflet-container')) return

    import('leaflet').then(L => {
      if (!mapRef.current || mapRef.current.classList.contains('leaflet-container')) return

      delete (L.Icon.Default.prototype as any)._getIconUrl
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
        iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
        shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
      })

      const map = L.map(mapRef.current!, {
        zoomControl: true,
        scrollWheelZoom: false,
        attributionControl: false,
      })
      mapInstance.current = map

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 17 }).addTo(map)
      map.setView([GORIS_LAT, GORIS_LNG], 13)

      const icon = L.divIcon({
        className: '',
        html: `<div style="width:20px;height:20px;border-radius:50% 50% 50% 0;rotate:-45deg;background:#B5431F;border:2.5px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,.4)"></div>`,
        iconSize: [20, 20],
        iconAnchor: [10, 20],
        popupAnchor: [0, -24],
      })

      L.marker([GORIS_LAT, GORIS_LNG], { icon })
        .addTo(map)
        .bindPopup('<strong style="font-family:serif;font-size:14px">Goris, Armenia</strong>', { closeButton: false })
        .openPopup()
    })

    return () => {
      if (mapInstance.current) {
        mapInstance.current.remove()
        mapInstance.current = null
      }
    }
  }, [])

  return (
    <>
      <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css" />
      <div ref={mapRef} style={{ width: '100%', height: '100%' }} />
    </>
  )
}
